'use client'
/* eslint-disable react-hooks/exhaustive-deps */
import { useLazyQuery } from '@apollo/client'
import { useCartContext } from '@mercadoni/sinister/dist/cjs/cart'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client'
import { getProductRecommendations } from '@mercadoni/sinister/dist/cjs/productv2/services'
import React, { useEffect, useMemo, useState } from 'react'
interface RecomendationProduct {
  id: string
  name: string
  price: number
  imageUrl: string
  storeReference: string
  storeId: string
  storeName: string
}
interface Props {
  children: React.ReactNode
}

const GrocerContext = React.createContext<{
  forgotSomethingProducts: RecomendationProduct[]
  setCallforgotSomething: React.Dispatch<React.SetStateAction<boolean>>
}>({
  forgotSomethingProducts: [],
  setCallforgotSomething: () => {
    return false
  },
})

export const GrocerProvider = (props: Props) => {
  const { cart } = useCartContext()
  const [forgotSomethingProducts, setForgotSomethingProducts] = useState<
    RecomendationProduct[]
  >([])
  const [callforgotSomething, setCallforgotSomething] = useState<boolean>(false)

  const { clientId, forgotSomethingV2 } = UseClientModelContext()

  const [getForgotSomething] = useLazyQuery(getProductRecommendations, {
    context: { version: 'v3' },
    onCompleted: (res) => {
      setForgotSomethingProducts(res.getProductRecommendations)
    },
  })
  useEffect(() => {
    if (
      forgotSomethingV2 &&
      callforgotSomething &&
      clientId &&
      cart.id &&
      cart?.store?.reference
    ) {
      getForgotSomething({
        variables: {
          getProductRecommendationsInput: {
            clientId,
            cartId: cart.id,
            storeReference: cart?.store?.reference,
            type: 'FORGOT_SOMETHING',
            data: {},
          },
        },
      })
    }
  }, [cart.id, callforgotSomething])

  const value = useMemo(
    () => ({
      forgotSomethingProducts,
      setCallforgotSomething,
    }),
    [forgotSomethingProducts]
  )

  return <GrocerContext.Provider value={value} {...props} />
}

export const UseGrocerContext = () => {
  const context = React.useContext(GrocerContext)
  if (!context) {
    throw new Error('GrocerProvider: no context')
  }
  return context
}
